import { render } from "./PermissionsDocumentation.vue?vue&type=template&id=29340f26&scoped=true"
import script from "./PermissionsDocumentation.vue?vue&type=script&lang=js"
export * from "./PermissionsDocumentation.vue?vue&type=script&lang=js"

import "./PermissionsDocumentation.vue?vue&type=style&index=0&id=29340f26&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\reportpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29340f26"]])

export default __exports__